// extracted by mini-css-extract-plugin
export default {"z-table-row":"z-table-row_z-table-row__JugLi","z-table-row__item":"z-table-row_z-table-row__item__vAlc+","z-table-row__actions":"z-table-row_z-table-row__actions__7sloo"};